module.exports = __webpack_public_path__ + "img/banner_2023.069fe04b.png";